import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { isEmpty } from 'lodash';
import { SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK } from '@eb/social-login-facebook';

import CheckoutSignInScreen from './CheckoutSignInScreen';
import {
    onCheckoutSignInHeightChange as onCheckoutSignInHeightChangeAction,
    lookupUserForCheckout as lookupUserForCheckoutAction,
    logInCheckoutUser as logInCheckoutUserAction,
    moveBackCheckout as moveBackCheckoutAction,
    clearAuthNotification as clearAuthNotificationAction,
    fbAccountNotConnected as fbAccountNotConnectedAction,
} from '../../actions/auth';
import { trackTermsOfServiceClicked as trackTermsOfServiceClickedAction } from '../../actions/gaTracking';
import {
    socialLogInCheckoutUser as socialConnectVerifiedAction,
    socialLogInUserAuthorized as socialLogInUserAuthorizedAction,
    socialLogInUserNotAuthorized as socialLogInUserNotAuthorizedAction,
    socialProviderClick as socialProviderClickAction,
} from '../../actions/social';

const _mapStateToProps = ({ authentication, form, social }) => ({
    currentFormType: authentication.currentFormType,
    form,
    email: authentication.email,
    socialData: social.socialData,
    locale: authentication.locale,
    recaptcha2PublicKey: authentication.recaptcha2PublicKey,
    recaptcha3PublicKey: authentication.recaptcha3PublicKey,
    showCaptcha: authentication.displayCaptcha,
    fp: authentication.fp,
    socialSSOSettings: {
        [SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK]:
            authentication.socialSSOSettings[
                SOCIAL_EXTERNAL_IDENTITY_PROVIDER_FACEBOOK
            ],
    },
    authNotificationOptions: authentication.authNotificationOptions,
    linkedAccountSuccessUrl: authentication.linkedAccountSuccessUrl,
    shouldRenderAuthNotification: !isEmpty(
        authentication.authNotificationOptions,
    ),
    authTypeSetting: authentication.authTypeSetting,
    stld: authentication.stld,
    disableRecaptcha3: authentication.disableRecaptcha3,
    referrer: authentication.referrer,
    userHasSoftAccount: authentication.userHasSoftAccount,
});

const _mapDispatchToProps = {
    onCheckoutSignInHeightChange: onCheckoutSignInHeightChangeAction,
    clearAuthNotification: clearAuthNotificationAction,
    moveBack: moveBackCheckoutAction,
    onLookupUserForCheckout: lookupUserForCheckoutAction,
    onFBAccountNotConnected: fbAccountNotConnectedAction,
    onLogInUser: logInCheckoutUserAction,
    onSocialConnectVerified: socialConnectVerifiedAction,
    onSocialConnectNotAuthorized: socialLogInUserAuthorizedAction,
    onSocialLogInUserAuthorized: socialLogInUserNotAuthorizedAction,
    handleSocialProviderClick: socialProviderClickAction,
    onTermsOfServiceClick: trackTermsOfServiceClickedAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(CheckoutSignInScreen),
);
